import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { getTranslations } from '../utils/translations';
import './Services.css';

const servicesData = [
  {
    icon: '🏨',
    key: 'hotelRentals'
  },
  {
    icon: '🚗',
    key: 'carRentals'
  },
  {
    icon: '✈️',
    key: 'businessTrips'
  },
  {
    icon: '🗺️',
    key: 'tripPlanning'
  },
  {
    icon: '🎯',
    key: 'adrenalineRush'
  }
];

export default function Services() {
  const { language } = useLanguage();
  const t = getTranslations(language);
  
  const services = servicesData.map(service => ({
    ...service,
    title: t.services[service.key].title,
    description: t.services[service.key].description
  }));
  
  return (
    <section id="services" className="services">
      <div className="services-container">
        <h2 className="services-title">{t.services.title}</h2>
        <p className="services-subtitle">
          {t.services.subtitle}
        </p>
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">{service.icon}</div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
